import React from 'react';

interface Props {
  onAccept(): void;
  onDecline(): void;
}

// NOTE: to test this component, clear cookies.
//  consent is stored both in localStorage and in the 3rd party component's cookie.
const CookieConsent = React.lazy(() => import('react-cookie-consent'));

class ErrorBoundary extends React.Component<{
    children: React.ReactNode
}, { hasError: boolean }> {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('CookieConsent failed to load', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return null; // Silently fail
        }
        return this.props.children;
    }
}

export function EUOnlyCookieConsent({ onAccept, onDecline }: Props) {
  return (
    <ErrorBoundary>
        <React.Suspense fallback={null}>
            <CookieConsent
                location="bottom"
                buttonText="Accept"
                declineButtonText="Decline"
                enableDeclineButton
                cookieName="eu_cookie_consent"
                style={{ background: "#2B373B" }}
                buttonStyle={{ color: "#fff", fontSize: "14px", background: "#c58ed4" }}
                declineButtonStyle={{ color: "#fff", fontSize: "14px", background: "#555" }}
                expires={365}
                onAccept={onAccept}
                onDecline={onDecline}
            >
                We use cookie to enhance your experience.
                You can opt-in or opt-out of tracking.
            </CookieConsent>
        </React.Suspense>
    </ErrorBoundary>
  );
}


